<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1XqNCU/tc-custom/9781416503712.jpg?1730494023322" alt="This image is the cover for the book Book of the Sword, Samurai Girl"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Book of the Sword, Samurai Girl
      </h1>
      <p class="bookDescription body article font2">
        <b>When I was six months old, I dropped from the sky -- the lone survivor of a deadly Japanese plane crash. The newspapers called me Heaven. I was adopted by a wealthy family in Tokyo, pampered, and protected. For nineteen years, I thought I was lucky. <br/><br/> I'm learning how wrong I was.</b><br/><br/><b>They say your life begins on your wedding day.</b><br/><br/> Here's what happened on mine: <br/>I lost the person I love most. <br/>I learned that everything I knew about my family was a lie. <br/>Now I'm being hunted. I must fight back, or die. <br/><br/> My life ended that day. <br/>The old Heaven is gone. <br/><br/><b>I AM SAMURAI GIRL.</b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Carrie Asai
      </h2>
      
      <p class="authorDescription body article">Carrie Asai is the author of The Book of the Heart, a Simon & Schuster book.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Simon Pulse
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?bf08de2a